// @flow
import React, { Fragment } from "react";
import ReactModal from "react-modal";

type Props = {
  id: number,
  onClose: ?Function,
  style: object
};

type State = {
  loaded: boolean,
  html: ?string
};

const customStyles = (show, style = {}) => ({
  overlay: {
    zIndex: 999999999,
    display: show ? "block" : "none",
    backgroundColor: "rgba(255, 255, 255, 0.5)"
  },
  content: {
    paddingTop: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: "initial",
    borderRadius: 0,
    overflowY: "scroll",
    width: window.innerWidth > 768 ? "80%" : "100%",
    height: "100%",
    maxWidth: "1600px",
    border: 0,
    backgroundColor: "#fafbfd",
    boxShadow: "-1px 0px 2px rgba(0, 0, 0, 0.15)",
    ...style
  }
});

export default class RegistrationModal extends React.Component<Props, State> {
  state = {
    loaded: false,
    html: null
  };

  render() {
    const { onClose, children, show, style } = this.props;
    return (
      <ReactModal
        isOpen={true}
        ariaHideApp={false}
        onRequestClose={onClose}
        style={customStyles(show, style)}
      >
        {children}
      </ReactModal>
    );
  }
}
